import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Link } from "react-router-dom";
import { AddSigner } from "../../../assets/logos/icons";
import { SimpleLoading, PromotionalFooterPure } from "../../pures";
import ConfigurationAdministratePanelPure from "../../pures/configuration-administrate/configuration-administrate-panel.pure";
import "./configuration-administrate.css";

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <strong>{props.title}</strong>
      <p>{props.content}</p>
      <p>{props.subContent}</p>
      <p>{props.restContent}</p>
      <p>{props.lastContent}</p>
    </a>
  );
};

const ConfigurationAdministrateView = (props) => {
  const { t } = useTranslation();

  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    boxShadow: "1px 1px 3px #959595",
    paddingTop: "10px",
    // width: 'auto'
  };

  const containerTableAndHeadersStyles = {
    // display: 'grid',
    paddingTop: "10px",
    maxWidth: "100%",
  };

  // Hooks to show and hide Tooltip
  const [open, setOpen] = useState(false);
  const handleOnChangeTooltip = () => setOpen(!open);
  const hiddeTooltip = () => setOpen(false);

  return (
    <div className="configurationAdministrateView-administrateStyle">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className="configurationAdministrateView-container"
          >
            <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="configurationAdministrateView-container-head"
              >
                <div className="configurationAdministrateView-head-signers">
                  <h3 className="configurationAdministrateView-subtitleContract">
                    {t("configurationAdministrateView.signers")}
                  </h3>
                </div>
              </Grid>
              <Grid
                container
                className="configurationAdministrateView-administrate"
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
              >
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="configurationAdministrateView-container"
                >
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    className="configurationAdministrateView-containerAdd"
                  >
                    <button
                      className="configurationAdministrateView-new-signer"
                      onClick={props.insert}
                    >
                      <img
                        src={AddSigner}
                        alt="icon"
                        width={23}
                        className="configurationAdministrateView-iconAdd"
                      ></img>
                      {t("configurationAdministrateView.newSigner")}
                    </button>

                    <Tooltip
                      position="right"
                      anchorElement="target"
                      content={(props) => {
                        return (
                          <TooltipContentTemplate
                            title={t("configurationPanelView.toolTipFirst")}
                            content={t(
                              "configurationPanelView.tooltipFirstDetail"
                            )}
                            subContent={t(
                              "configurationPanelView.tooltipSecondDetail"
                            )}
                            restContent={t(
                              "configurationPanelView.tooltipThirdDetail"
                            )}
                            lastContent={t(
                              "configurationPanelView.tooltipFourthDetail"
                            )}
                          />
                        );
                      }}
                    >
                      <i
                        className="configurationAdministrateView-tooltip k-icon k-i-information"
                        title={t("configurationPanelView.tooltipClic")}
                      // onClick={() => handleOnChangeTooltip()}
                      // onMouseOut={() => hiddeTooltip()}
                      />
                    </Tooltip>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    className="configurationAdministrateView-administrate-pure"
                  >
                    <ConfigurationAdministratePanelPure
                      {...props}
                      deleteCollaborator={props.deleteCollaborator}
                      validator={props.validator}
                      validateInput={props.validateInput}
                      saveError={props.saveError}
                      cancelError={props.cancelError}
                      loading={props.loading}
                      loadingComponent={props.loadingComponent}
                      inputValidate={props.inputValidate}
                      onBlurValidateEmail={props.onBlurValidateEmail}
                      editProfileUser={props.editProfileUser}
                      cancel={props.cancel}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="configurationAdministrateView-back-container"
                >
                  <Link
                    to="/configuration"
                    className="configurationAdministrateView-link"
                  >
                    <button
                      onClick={props.scrollWindow}
                      className="configurationAdministrateView-button-back"
                      style={{ marginLeft: "20px" }}
                    >
                      {t("configurationPanelView.buttonBack")}
                    </button>
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  className="configurationAdministrateView-container"
                >
                  <PromotionalFooterPure />
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Container>
      )}
    </div>
  );
};

export { ConfigurationAdministrateView as default };
